// import { logout } from "@carrier/reactauthwrapper";
import { logout } from '@carrier-sce-sharedpackages/auth-module';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import axios from "axios";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import useStyles from "./Style";
import getUsernameFromToken from "./User";
import appConfig from "./config";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
const settings = ["Logout"];
const icons = [<ExitToAppIcon />];
function Root() {
  const classes = useStyles();
  const username = getUsernameFromToken();
  console.log(process.env)
  const get_baseURL = ()=>{
    const react_app_env = process.env.REACT_APP_ENV;
    switch (react_app_env){
      case "pilot":
         return "https://0gonzrljxe.execute-api.us-east-1.amazonaws.com/test/api"
      case "test":
        return "https://5xxznjdvq6.execute-api.us-east-1.amazonaws.com/local/api"
      case "production":
        return "https://pxc40xmnqa.execute-api.us-east-1.amazonaws.com/prod/api"
      case "local":
        return "https://5xxznjdvq6.execute-api.us-east-1.amazonaws.com/local/api"
      default : 
        return "http://localhost:5000"
    }
  }
  const base_url = get_baseURL();
  const handleLogout = () => {
    sessionStorage.removeItem("user");
    logout(appConfig.api);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchAPI = axios.create({
    // baseURL: "http://localhost:5000",
    // baseURL: "https://gxrszhu8sf.execute-api.us-east-1.amazonaws.com/dev/",
    // baseURL : "https://g4nwn1xq2m.execute-api.us-east-1.amazonaws.com/dev/api",
    baseURL: base_url
  });
  return (
    // <ReactAuthWrapper appConfig={appConfig.api}>
    <App username={username} classes={classes} fetchAPI={fetchAPI} />
    // </ReactAuthWrapper>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
serviceWorker.unregister();
